import * as React from 'react';
import * as style from './style.css';
import { ArticleParagraph1, Image, Tooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { IRatingHelp } from '../../types/developerV2/awards';

interface IAwardCardProps {
  place: string;
  placeLabel: string;
  description: string;
  icon: string;
  help?: IRatingHelp;
}

export const RatingCard = ({ place, placeLabel, description, icon, help }: IAwardCardProps) => {
  return (
    <div className={style['card']}>
      <div className={style['place-wrapper']}>
        <div className={style['place']}>
          <div className={style['place-number']}>{place}</div>
          <ArticleParagraph1>{placeLabel}</ArticleParagraph1>
        </div>
        <div className={style['icon']}>
          <Image src={icon} alt={`${place} ${description}`} preloader={false} height={45} width={45} />
        </div>
      </div>
      <div>
        <UIText2 display="inline">{description}</UIText2>
        {help && (
          <Tooltip title={help.text} header={help.title} theme="white">
            <div className={style['description-icon']}>
              <div className={style['description-icon--inner']}>
                <IconFunctionalInformationCircle16 />
              </div>
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
